import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NotificationComponent } from '@tdwb/core';
import { AgreementsBase } from '../agreements.base';

@Component({
  selector: 'td-wb-old-nasdaq',
  templateUrl: './old-nasdaq.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [NgTemplateOutlet, NotificationComponent]
})
export class OldNasdaqComponent extends AgreementsBase {
  constructor() { super(); }
}
